export default __webpack_public_path__ + "static/posz-50cd8ec557f387388d2d121f6f7dcecc.jpg";